export const HOST_CONTRACT_COUNT_DATA = {
  waitingApprovalCount: 1,
  waitingCheckinCount: 3,
  waitingCheckoutCount: 6,
  waitingCheckFinishCount: 0,
  waitingApprovalRoomPics: ['room/653306de-ab84-47dc-98c4-03236a926dd5.png'],
  waitingCheckinRoomPics: [
    'room/754a0ddd-5268-43c2-8c66-1ebfaf952955.jpg',
    'room/6fa09fbc-6fd7-45bf-bc0c-edd3e60aa80c.jpg',
    'room/653306de-ab84-47dc-98c4-03236a926dd5.png',
  ],
  waitingCheckoutRoomPics: [
    'room/F6BC7882-48EB-4A56-BAE1-76914960D876.png',
    'room/93640df4-9bbc-427c-9e1d-9096ec2e2185.gif',
    'room/F6BC7882-48EB-4A56-BAE1-76914960D876.png',
    'room/93640df4-9bbc-427c-9e1d-9096ec2e2185.gif',
    'room/F6BC7882-48EB-4A56-BAE1-76914960D876.png',
    'room/93640df4-9bbc-427c-9e1d-9096ec2e2185.gif',
  ],
  waitingCheckFinishRoomPics: [],
}
